import { FC } from "react";
import { motion } from "framer-motion";
import { SlideItem } from "./components/SlideItem";
import { useHeroWithSlide } from "./hooks/useHeroWithSlide";
import { HeroWithSlideProps } from "./types";
import WIconButton from "../wicon-button/WIconButton";
import { faArrowLeft, faArrowRight } from "@fortawesome/pro-regular-svg-icons";

export const HeroWithSlide: FC<HeroWithSlideProps> = ({ items, autoPlay }) => {
  const {
    slider,
    activeIndex,
    setCurrentIndex,
    swipeRef,
    handlePrev,
    handleNext,
  } = useHeroWithSlide({
    itemsLength: items.length,
    autoPlay,
    items: items.map((item) => ({
      type: item?.image?.mime?.startsWith("image") ? "image" : "video",
    })),
  });

  return (
    <div className="relative h-[100dvh]" ref={swipeRef}>
      <div ref={slider} className="overflow-hidden flex-1 h-full">
        {items.map((item, index) => (
          <motion.div
            key={index}
            className="slide-item h-full flex-1 flex flex-col"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
            style={{
              display: index === activeIndex ? "block" : "none",
            }}
          >
            <SlideItem {...item} />
          </motion.div>
        ))}
      </div>
      {items?.length > 1 && (
        <div className="absolute inset-0 flex items-center justify-between z-[100] pointer-events-none">
          {/* Left Arrow */}
          <div
            className="lg:flex items-center  hidden h-full px-5 bg-gradient-to-r from-white/75 pointer-events-auto"
            onClick={handlePrev}
          >
            <WIconButton
              icon={faArrowLeft}
              type="white"
              className="border-0  text-ekblue"
            />
          </div>

          {/* Indicators (Centered at the bottom) */}
          <div className="absolute bottom-0 flex items-center gap-2 pb-4 lg:pb-12 w-full justify-center pointer-events-auto">
            {items.map((_, index) => (
              <div
                key={index}
                className={`h-5 w-5  rounded-full cursor-pointer ${
                  index === activeIndex ? "bg-[#358A4F]" : "bg-white"
                }`}
                onClick={() => setCurrentIndex(index)}
              />
            ))}
          </div>

          {/* Right Arrow */}
          <div
            className="lg:flex hidden items-center h-full px-5 bg-gradient-to-l from-white/75 pointer-events-auto"
            onClick={handleNext}
          >
            <WIconButton
              icon={faArrowRight}
              type="white"
              className="border-0 text-ekblue"
            />
          </div>
        </div>
      )}
    </div>
  );
};
